<mat-toolbar>
  <div class="footer_text">©{{ currentYear }} Silqware Pty Ltd. All Rights Reserved</div>
  <a
    class="footer_text_version-P hover:underline"
    [routerLink]="'privacy-policy'"
    target="_blank"
    rel="noopener noreferrer"
  >
    Privacy Policy
  </a>
  <a
    class="footer_text_version-E hover:underline"
    [routerLink]="'/end-user-licence-agreement'"
    target="_blank"
    rel="noopener noreferrer"
  >
    End User Licence Agreement
  </a>
  <div class="footer_text_version">Version {{ VERSION }}</div>
</mat-toolbar>
